import gql from 'graphql-tag'

export const COMMISSION_LIST_DELETE_MUTATION = gql`
    mutation commissionListDelete(
        $id: ID!
    ) {
        commissionListDelete(
            id: $id
        ) {
            status
        }
    }
`
